module.exports = __webpack_public_path__ + "static/media/Instagram.869feb85.svg";